/**
 * Hyros Adapter
 *
 * Hyros does not have a commerce event API. It models a visitor journey as a
 * chain of action tags, and the Universal Script records page visits and the
 * landing tag on its own. Everything the shop wants to see beyond that has to
 * be added as an action tag through window.hrs.addLeadTag().
 *
 * This adapter therefore maps the shopping funnel milestones to Hyros action
 * tags. Sales are not sent from the browser at all: Hyros pulls orders from
 * the WooCommerce REST API through its own WooCommerce integration.
 *
 * @see https://docs.hyros.com/how-to-track-without-a-thank-you-page/
 * @see https://docs.hyros.com/edit-tags-from-the-hyros-universal-script/
 */

(function (pmw, undefined) {

	/**
	 * The action tags added to the visitor journey, keyed by PMW event name.
	 *
	 * The exclamation mark prefix is the Hyros convention for action tags
	 * (their own defaults are !clicked and !submitted).
	 */
	const LEAD_TAGS = {
		add_to_cart   : "!add_to_cart",
		begin_checkout: "!begin_checkout",
		purchase      : "!purchase",
	}

	class HyrosAdapter {

		/**
		 * Adapt an event for Hyros
		 *
		 * @param {Object} eventData - Standardized event data
		 * @param {string} eventName - Standardized event name
		 * @param {Object} context - Additional context
		 * @returns {Object|null} - Hyros formatted event or null to skip
		 */
		adapt(eventData, eventName, context) {

			if (typeof eventName !== "string") return null
			if (!LEAD_TAGS[eventName]) return null

			return {
				// For Hyros the action tag is the event
				event_name: LEAD_TAGS[eventName],
			}
		}
	}

	const adapter = new HyrosAdapter()

	pmw.registerAdapter("hyros", adapter, {
		supportsS2S               : false,
		supportsEventDeduplication: false,
		isActive                  : () => pmwDataLayer?.pixels?.hyros?.product_hash ? true : false,
	})

}(window.pmw = window.pmw || {}));
